// import React, { useEffect, useState } from "react";
// import backgroundImage from "../../assets/images/page3_parallax01.jpg";
// import seconbackground from "../../assets/images/page3_parallax02.jpg";
// import "../Services/Services.css";
// import Footer from "../Footer/Footer";
// import { FaArrowRight, FaChevronRight } from "react-icons/fa";
// import { FaCheck } from "react-icons/fa";
// import { choosePlan } from "../api/api";
// import aboutbanners from "../../assets/images/about-head-banner.jpg";

// const faqData = [
//   {
//     question: "What is ConnectToVow?",
//     answer:
//       "ConnectToVow is a privacy-focused matchmaking platform designed for individuals who are ready for meaningful, marriage-intentional relationships. We use classical temperament theory and a deep compatibility assessment to help you find your most suitable partner.",
//   },
//   {
//     question: "How is ConnectToVow different from dating apps?",
//     answer:
//       "Unlike casual dating apps, ConnectToVow is not swipe-based or hookup-driven. We focus on compatibility, emotional maturity, and intentional connection. Every profile is manually reviewed, and our temperament-based system ensures you're matched with someone aligned with your core values and long-term vision.",
//   },
//   {
//     question: "Who can join ConnectToVow?",
//     answer: [
//       "Anyone who is:",
//       "21 years and above",
//       "Emotionally ready and committed to finding a life partner",
//       "Willing to be honest about who they are and what they want",
//       "Open to personality-based matchmaking",
//     ],
//   },
//   {
//     question: "How does the temperament matching work?",
//     answer:
//       "We use the classical temperament theory (choleric, sanguine, melancholic, phlegmatic) to assess your natural emotional and behavioral inclinations. This helps us pair you with someone whose traits complement yours, ensuring more understanding and harmony in the relationship.",
//   },
//   {
//     question: "Is my information safe?",
//     answer:
//       "Absolutely. We take your privacy and data security seriously. All profiles go through manual verification, and we never sell or share your data with third parties.",
//   },
//   {
//     question: "What will you do with my data?",
//     answer:
//       "We do not share your data with any third parties. All documents submitted during registration are used strictly for verification purposes and are permanently removed from our servers once the verification process is complete.",
//   },
//   {
//     question: "What kind of questions are in the compatibility assessment?",
//     answer: [
//       "Our assessment includes:",
//       "Relationship goals and non-negotiables",
//       "Emotional triggers and conflict styles",
//       "Value systems, lifestyle choices, and expectations",
//       "It's designed to uncover who you are, not just what you like.",
//     ],
//   },
//   {
//     question: "What happens after I create a profile?",
//     answer: [
//       "After profile creation:",
//       "Our team manually verifies your details",
//       "You’ll receive personalized matches based on your temperament and values",
//       "You can begin safe, meaningful conversations within the platform",
//     ],
//   },
//   {
//     question: "Is ConnectToVow a free service?",
//     answer: {
//       intro:
//         "No, ConnectToVow is not a free service. We have a one-time basic admin fee for first-time subscribers. ConnectToVow offers a three-tier paid subscription model tailored to your needs:",
//       plans: [
//         {
//           name: "Starter Plan",
//           features: [
//             "Basic connection reports",
//             "Low priority matching",
//             "Low access to community events",
//           ],
//         },
//         {
//           name: "Premium Plan",
//           features: [
//             "Basic connection reports",
//             "High priority matching",
//             "Limited access to community events",
//           ],
//         },
//         {
//           name: "Elite+ Counselling Plan",
//           features: [
//             "Full connection reports",
//             "High priority matching",
//             "Full access to community events",
//             "Access to professional counselor support",
//           ],
//         },
//       ],
//     },
//   },
//   {
//     question: "Can I hide my profile or delete my account?",
//     answer:
//       "Yes. You’re always in control. You can deactivate, hide, or permanently delete your account from your settings.",
//   },
//   {
//     question: "What if I’m not tech-savvy?",
//     answer:
//       "We designed ConnectToVow to be user-friendly and intuitive. Plus, our support team is available to guide you if you need help at any point.",
//   },
//   {
//     question: "Is there a success rate or testimonials?",
//     answer:
//       "We’ve seen encouraging stories already, and we’re working to share authentic success stories and testimonials from real users who’ve found lasting love on ConnectToVow.",
//   },
//   {
//     question: "What’s the next step after finding a match?",
//     answer:
//       "ConnectToVow encourages healthy communication. Once a match is formed, you can chat on the platform, participate in guided conversation prompts, and when you both feel ready, move toward physical meet-ups or counseling at your pace.",
//   },
// ];

// const Services = () => {
//   const [plans, setPlans] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const toggleFAQ = (index) => {
//     setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
//   };

//   useEffect(() => {
//     const choosePlanfuntion = async () => {
//       try {
//         const response = await choosePlan();
//         if (response?.success && Array.isArray(response.data)) {
//           setPlans(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching plans:", error);
//       }
//     };
//     choosePlanfuntion();
//   }, []);

//   const renderAnswer = (answer, question) => {
//     if (Array.isArray(answer)) {
//       const isNumbered = question === "What happens after I create a profile?";

//       return (
//         <>
//           <p className="textzeroindex">{answer[0]}</p>
//           {isNumbered ? (
//             <ol className="faq-numbered-list">
//               {answer.slice(1).map((item, i) => (
//                 <li key={i}>{item}</li>
//               ))}
//             </ol>
//           ) : (
//             <ul>
//               {answer.slice(1).map((item, i) => (
//                 <li key={i}>{item}</li>
//               ))}
//             </ul>
//           )}
//         </>
//       );
//     } else if (typeof answer === "object") {
//       return (
//         <>
//           <p>{answer.intro}</p>
//           {answer.plans.map((plan, i) => (
//             <div key={i} style={{ marginTop: "1rem" }}>
//               <h4>{plan.name}</h4>
//               <ul>
//                 {plan.features.map((feature, j) => (
//                   <li key={j}>{feature}</li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </>
//       );
//     } else {
//       return <p>{answer}</p>;
//     }
//   };

//   return (
//     <div className="services-container">
//       <div
//         className="bannersec"
//         style={{
//           backgroundImage: `url(${aboutbanners})`,
//         }}
//       >
//         <h4>Membership</h4>
//         <p>
//           Home{" "}
//           <span>
//             <FaChevronRight />
//           </span>{" "}
//           Membership
//         </p>
//       </div>

//       <div className="subscription-cards">
//         <div className="containerall">
//           <h1 className="serv-title">Subscription Tier Comparison</h1>
//           <div className="card-container">
//             {plans.map((plan, index) => (
//               <div className="card" key={plan.id}>
//                 <h3 className="card-title">{plan.name}</h3>
//                 <ul className="features">
//                   <div className="feature-row">
//                     <span className="cardlabel">Profile Verification</span>
//                     <span className="check-icon">
//                       <FaCheck />
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">
//                       Temperament & Values Assessment
//                     </span>
//                     <span className="check-icon">
//                       <FaCheck />
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">AI Compatibility Matching</span>
//                     <span className="check-icon">
//                       <FaCheck />
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Admin-Guided Connections</span>
//                     <span className="check-icon">
//                       <FaCheck />
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Matches per Month</span>
//                     <span className="check-icon">{plan.matches}</span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Chat Access After Match</span>
//                     <span className="check-icon">
//                       <FaCheck />
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Connection Reports</span>
//                     <span className="check-icon">
//                       {plan.counselling === "0" ? "Basic" : "Full"}
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Counselor Support</span>
//                     <span className="check-icon">
//                       {plan.counselling === "1" ? "Included" : "Not Included"}
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Priority Matching</span>
//                     <span className="check-icon">
//                       {plan.priority === "high" ? "High" : "Low"}
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Event Access</span>
//                     <span className="check-icon">
//                       {plan.event_access === "0" && "Limited"}
//                       {plan.event_access === "1" && "Standard"}
//                       {plan.event_access === "2" && "Full"}
//                     </span>
//                   </div>
//                   <div className="feature-row">
//                     <span className="cardlabel">Cost</span>
//                     <span className="check-icon">
//                       {plan.price ? "Variable" : "N/A"}
//                     </span>
//                   </div>
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="faq-section">
//           <div className="containerall">
//             <h2 className="serv-title">Frequently Asked Questions</h2>
//             <div className="faq-sec-in">
//               {faqData.map((faq, index) => (
//                 <div className="accordion-item" key={index}>
//                   <div
//                     className={`accordion-header ${
//                       activeIndex === index ? "active" : ""
//                     }`}
//                     onClick={() => toggleFAQ(index)}
//                   >
//                     <div className="icon">
//                       {activeIndex === index ? "−" : "+"}
//                     </div>
//                     <div className="accordion-title">{faq.question}</div>
//                   </div>
//                   {activeIndex === index && (
//                     <div className="accordion-body open">
//                       {/* {renderAnswer(faq.answer)} */}
//                       {renderAnswer(faq.answer, faq.question)}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Services;

import React, { useEffect, useState } from "react";
import backgroundImage from "../../assets/images/page3_parallax01.jpg";
import seconbackground from "../../assets/images/page3_parallax02.jpg";
import "../Services/Services.css";
import Footer from "../Footer/Footer";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { choosePlan, miscFaqs } from "../api/api";
import aboutbanners from "../../assets/images/about-head-banner.jpg";

const faqData = [
  {
    question: "What is ConnectToVow?",
    answer:
      "ConnectToVow is a privacy-focused matchmaking platform designed for individuals who are ready for meaningful, marriage-intentional relationships. We use classical temperament theory and a deep compatibility assessment to help you find your most suitable partner.",
  },
  {
    question: "How is ConnectToVow different from dating apps?",
    answer:
      "Unlike casual dating apps, ConnectToVow is not swipe-based or hookup-driven. We focus on compatibility, emotional maturity, and intentional connection. Every profile is manually reviewed, and our temperament-based system ensures you're matched with someone aligned with your core values and long-term vision.",
  },
  {
    question: "Who can join ConnectToVow?",
    answer: [
      "Anyone who is:",
      "21 years and above",
      "Emotionally ready and committed to finding a life partner",
      "Willing to be honest about who they are and what they want",
      "Open to personality-based matchmaking",
    ],
  },
  {
    question: "How does the temperament matching work?",
    answer:
      "We use the classical temperament theory (choleric, sanguine, melancholic, phlegmatic) to assess your natural emotional and behavioral inclinations. This helps us pair you with someone whose traits complement yours, ensuring more understanding and harmony in the relationship.",
  },
  {
    question: "Is my information safe?",
    answer:
      "Absolutely. We take your privacy and data security seriously. All profiles go through manual verification, and we never sell or share your data with third parties.",
  },
  {
    question: "What will you do with my data?",
    answer:
      "We do not share your data with any third parties. All documents submitted during registration are used strictly for verification purposes and are permanently removed from our servers once the verification process is complete.",
  },
  {
    question: "What kind of questions are in the compatibility assessment?",
    answer: [
      "Our assessment includes:",
      "Relationship goals and non-negotiables",
      "Emotional triggers and conflict styles",
      "Value systems, lifestyle choices, and expectations",
      "It's designed to uncover who you are, not just what you like.",
    ],
  },
  {
    question: "What happens after I create a profile?",
    answer: [
      "After profile creation:",
      "Our team manually verifies your details",
      "You’ll receive personalized matches based on your temperament and values",
      "You can begin safe, meaningful conversations within the platform",
    ],
  },
  {
    question: "Is ConnectToVow a free service?",
    answer: {
      intro:
        "No, ConnectToVow is not a free service. We have a one-time basic admin fee for first-time subscribers. ConnectToVow offers a three-tier paid subscription model tailored to your needs:",
      plans: [
        {
          name: "Starter Plan",
          features: [
            "Basic connection reports",
            "Low priority matching",
            "Low access to community events",
          ],
        },
        {
          name: "Premium Plan",
          features: [
            "Basic connection reports",
            "High priority matching",
            "Limited access to community events",
          ],
        },
        {
          name: "Elite+ Counselling Plan",
          features: [
            "Full connection reports",
            "High priority matching",
            "Full access to community events",
            "Access to professional counselor support",
          ],
        },
      ],
    },
  },
  {
    question: "Can I hide my profile or delete my account?",
    answer:
      "Yes. You’re always in control. You can deactivate, hide, or permanently delete your account from your settings.",
  },
  {
    question: "What if I’m not tech-savvy?",
    answer:
      "We designed ConnectToVow to be user-friendly and intuitive. Plus, our support team is available to guide you if you need help at any point.",
  },
  {
    question: "Is there a success rate or testimonials?",
    answer:
      "We’ve seen encouraging stories already, and we’re working to share authentic success stories and testimonials from real users who’ve found lasting love on ConnectToVow.",
  },
  {
    question: "What’s the next step after finding a match?",
    answer:
      "ConnectToVow encourages healthy communication. Once a match is formed, you can chat on the platform, participate in guided conversation prompts, and when you both feel ready, move toward physical meet-ups or counseling at your pace.",
  },
];

const Services = () => {
  const [plans, setPlans] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [faqsvalue, setfaqsvalue] = useState("");

  useEffect(() => {
    const FaqsData = async () => {
      const getDatas = await miscFaqs();
      console.log("get_feqs_Data", JSON.stringify(getDatas));
      setfaqsvalue(getDatas);
    };
    FaqsData();
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  useEffect(() => {
    const choosePlanfuntion = async () => {
      try {
        const response = await choosePlan();
        if (response?.success && Array.isArray(response.data)) {
          setPlans(response.data);
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };
    choosePlanfuntion();
  }, []);

  // const renderAnswer = (answer, question) => {
  //   if (Array.isArray(answer)) {
  //     const isNumbered = question === "What happens after I create a profile?";

  //     return (
  //       <>
  //         <p className="textzeroindex">{answer[0]}</p>
  //         {isNumbered ? (
  //           <ol className="faq-numbered-list">
  //             {answer.slice(1).map((item, i) => (
  //               <li key={i}>{item}</li>
  //             ))}
  //           </ol>
  //         ) : (
  //           <ul>
  //             {answer.slice(1).map((item, i) => (
  //               <li key={i}>{item}</li>
  //             ))}
  //           </ul>
  //         )}
  //       </>
  //     );
  //   } else if (typeof answer === "object") {
  //     return (
  //       <>
  //         <p>{answer.intro}</p>
  //         {answer.plans.map((plan, i) => (
  //           <div key={i} style={{ marginTop: "1rem" }}>
  //             <h4>{plan.name}</h4>
  //             <ul>
  //               {plan.features.map((feature, j) => (
  //                 <li key={j}>{feature}</li>
  //               ))}
  //             </ul>
  //           </div>
  //         ))}
  //       </>
  //     );
  //   } else {
  //     return <p>{answer}</p>;
  //   }
  // };

  const renderAnswer = (answer, question) => {
    if (Array.isArray(answer)) {
      const isNumbered = question === "What happens after I create a profile?";
      return (
        <>
          <p className="textzeroindex">{answer[0]}</p>
          {isNumbered ? (
            <ol className="faq-numbered-list">
              {answer.slice(1).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ol>
          ) : (
            <ul>
              {answer.slice(1).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </>
      );
    } else if (typeof answer === "object") {
      return (
        <>
          <p>{answer.intro}</p>
          {answer.plans.map((plan, i) => (
            <div key={i} style={{ marginTop: "1rem" }}>
              <h4>{plan.name}</h4>
              <ul>
                {plan.features.map((feature, j) => (
                  <li key={j}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </>
      );
    } else {
      const cleanedAnswer = answer.replace(
        /font-size:\s*\d+(\.\d+)?(px|pt|rem);?/gi,
        ""
      );
      return (
        <div
          className="faq-answer"
          dangerouslySetInnerHTML={{
            // __html: cleanedAnswer,
            __html: answer,
          }}
        />
      );
    }
  };

  return (
    <div className="services-container">
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>Membership</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          Membership
        </p>
      </div>

      <div className="subscription-cards">
        <div className="containerall">
          <h1 className="serv-title">Subscription Tier Comparison</h1>
          <div className="card-container">
            {plans.map((plan, index) => (
              <div className="card" key={plan.id}>
                <h3 className="card-title">{plan.name}</h3>
                <ul className="features">
                  <div className="feature-row">
                    <span className="cardlabel">Profile Verification</span>
                    <span className="check-icon">
                      <FaCheck />
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">
                      Temperament & Values Assessment
                    </span>
                    <span className="check-icon">
                      <FaCheck />
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">AI Compatibility Matching</span>
                    <span className="check-icon">
                      <FaCheck />
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Admin-Guided Connections</span>
                    <span className="check-icon">
                      <FaCheck />
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Matches per Month</span>
                    <span className="check-icon">{plan.matches}</span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Chat Access After Match</span>
                    <span className="check-icon">
                      <FaCheck />
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Connection Reports</span>
                    <span className="check-icon">
                      {plan.counselling === "0" ? "Basic" : "Full"}
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Counselor Support</span>
                    <span className="check-icon">
                      {plan.counselling === "1" ? "Included" : "Not Included"}
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Priority Matching</span>
                    <span className="check-icon">
                      {plan.priority === "high" ? "High" : "Low"}
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Event Access</span>
                    <span className="check-icon">
                      {plan.event_access === "0" && "Limited"}
                      {plan.event_access === "1" && "Standard"}
                      {plan.event_access === "2" && "Full"}
                    </span>
                  </div>
                  <div className="feature-row">
                    <span className="cardlabel">Cost</span>
                    <span className="check-icon">
                      {plan.price ? "Variable" : "N/A"}
                    </span>
                  </div>
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="faq-section">
          <div className="containerall">
            <h2 className="serv-title">Frequently Asked Questions</h2>
            <div className="faq-sec-in">
              {faqsvalue?.data?.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <div
                    className={`accordion-header ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="icon">
                      {activeIndex === index ? "−" : "+"}
                    </div>
                    <div className="accordion-title">{faq.question}</div>
                  </div>
                  {activeIndex === index && (
                    <div className="accordion-body open">
                      {renderAnswer(faq.answer, faq.question)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
